import { formatResearcherFullName } from 'utils/researcherName';
import { Link } from 'components/common';

export const renderLink = researcher => {
  const formattedName = formatResearcherFullName(researcher.name || '');
  if (researcher.researcherId > 0) {
    return (
      <Link to={`/researcher/${researcher.researcherId}`}>{formattedName}</Link>
    );
  }
  return <div>{formattedName}</div>;
};
